// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PtWC","col":"styles_col__2Yd17"};